export default __webpack_public_path__ + "static/media/welcomeImage_2_PROD.1ad2e6bd.jpg";